import React from "react";
import "../Styles/HomeCarousel.css";
import ContactInput from "./ContactInput";
import AppointmentBtn from "./AppointmentBtn";

const HomeCarousel = ({
  headingText,
  highlightText,
  description,
  image,
  showContactInput = false,
  showAppointmentBtn = false,
}) => {
  const parts = headingText.split(new RegExp(`(${highlightText})`, "i"));

  return (
    <div className="home-carousel-container">
      <div className="home-carousel-content">
        <h1 className="home-carousel-heading">
          {parts.map((part, index) =>
            part.toLowerCase() === highlightText.toLowerCase() ? (
              <span key={index} className="highlight-underline">
                {part}
              </span>
            ) : (
              <span key={index}>{part}</span>
            ),
          )}
        </h1>
        <p className="home-carousel-description">{description}</p>
        {showContactInput && <ContactInput />}
        {showAppointmentBtn && <AppointmentBtn />}
      </div>
      <div className="home-carousel-image-wrapper">
        <img
          src={image}
          alt="Carousel Visual"
          className="home-carousel-image"
        />
      </div>
    </div>
  );
};

export default HomeCarousel;
